var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMdpCle = function SvgMdpCle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.205,
    height: 18.048,
    viewBox: "0 0 15.205 18.048",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "fill:#fff"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.1-15.4a4.92,4.92,0,0,0-3.586-1.477A4.862,4.862,0,0,0-1.055-15.4a4.882,4.882,0,0,0-1.477,3.586,5.03,5.03,0,0,0,1.2,3.3.472.472,0,0,0-.422.141l-5.66,5.73a.483.483,0,0,0,0,.773v.035L-4.641.984A.5.5,0,0,0-3.85.967.482.482,0,0,0-3.867.176L-6.223-2.25l1.441-1.477,2.391,2.461A.5.5,0,0,0-1.6-1.283a.482.482,0,0,0-.018-.791L-4.008-4.5-.949-7.559A.472.472,0,0,0-.809-7.98a4.99,4.99,0,0,0,3.34,1.23A4.882,4.882,0,0,0,6.117-8.227a4.882,4.882,0,0,0,1.477-3.586A4.853,4.853,0,0,0,6.1-15.4ZM5.309-9.035a3.789,3.789,0,0,1-2.777,1.16A3.789,3.789,0,0,1-.246-9.035a3.789,3.789,0,0,1-1.16-2.777A3.789,3.789,0,0,1-.246-14.59a3.789,3.789,0,0,1,2.777-1.16,3.789,3.789,0,0,1,2.777,1.16,3.789,3.789,0,0,1,1.16,2.777A3.789,3.789,0,0,1,5.309-9.035Z",
    transform: "translate(7.611 16.875)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMdpCle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mdpCle.98bb40be.svg";
export { ForwardRef as ReactComponent };